class HoldToScroll {
    constructor(selector, scrollSpeed = 150, holdDelay = 500) {
      this.selector = selector;
      this.scrollSpeed = scrollSpeed;
      this.holdDelay = holdDelay;
      this.intervalId = null;
      this.timeoutId = null;
      this.isHolding = false;
      this.init();
    }
  
    init() {
      document.addEventListener("mousedown", e => this.handleStart(e));
      document.addEventListener("mouseup", () => this.stop());
      document.addEventListener("mouseleave", () => this.stop());
      document.addEventListener("touchstart", e => this.handleStart(e));
      document.addEventListener("touchend", () => this.stop());
      document.addEventListener("touchcancel", () => this.stop());
    }
  
    handleStart(e) {
      const button = e.target.closest(this.selector);
      if (!button) return;
  
      this.isHolding = true;
  
      this.timeoutId = setTimeout(() => {
        if (this.isHolding) {
          this.intervalId = setInterval(() => {
            if (this.isHolding && !button.disabled) {
              button.click();
            } else {
              this.stop();
            }
          }, this.scrollSpeed);
        }
      }, this.holdDelay);
    }
  
    stop() {
      this.isHolding = false;
      clearTimeout(this.timeoutId);
      clearInterval(this.intervalId);
    }
  }
  
new HoldToScroll(".swiper-button, [class*='swiper-button--']",250);  